/**
 * All credit goes to Chance (Reach UI), Haz (Reakit) and (fluentui)
 * for creating the base type definitions upon which we improved on
 */
import * as React from "react";
export function forwardRef(component) {
  return /*#__PURE__*/React.forwardRef(component);
}
//# sourceMappingURL=forward-ref.js.map